import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CallToAction from '../CallToAction';
import Map from './Map';

const CoverageStyles = styled.section`
  width: 100vw;
  background: var(--burnt);
  background: linear-gradient(
      0deg,
      rgba(40, 42, 48, 0.8),
      rgba(40, 42, 48, 0.8)
    ),
    url('https://autora-react.vercel.app/assets/img/parallax/parallax-1.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;

  .flex {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  .column {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-height: 100%;
  }

  .content {
    background: white;
    padding: 18px;
    max-width: 450px;
    margin-top: 60px;
    h3 {
      padding-bottom: 15px;
      margin: 0;
      font-size: 18px;
    }
    p {
      margin: 0;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 27px;
      /* or 193% */
      letter-spacing: 0.2px;
    }
    a {
      text-decoration: none;
      padding: 15px 0 0 0;
      display: block;
      color: var(--burnt);
    }
  }

  .new-content {
    h2 {
      color: white;
      text-transform: uppercase;
    }

    p {
      color: white;
      line-height: 28px;
      padding: 30px 0;
    }
  }

  // change the layout when viewed on an ipad or smaller
  @media only screen and (max-width: 810px) {
    .flex {
      grid-template-columns: 1fr;
    }

    h2,
    p {
      text-align: center;
    }

    .link-button {
      margin: 0 auto;
      width: 100%;
      display: block;
      text-align: center;
      padding-bottom: 30px;
    }
  }
`;

export default function Coverage({ title, body, locale, locations }) {
  return (
    <CoverageStyles>
      <div className="container flex">
        <Map locale={locale} locations={locations} />

        <div className="column">
          <div className="new-content">
            <h2>{title || 'Title Here'}</h2>
            <p>{body || 'body here'}</p>

            <Link className="link-button" to="/delivery">
              <CallToAction className="link-button">Find Out More</CallToAction>
            </Link>
          </div>
        </div>
      </div>
    </CoverageStyles>
  );
}

Coverage.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  locale: PropTypes.array.isRequired,
  locations: PropTypes.any,
};
